export default __webpack_public_path__ + "static/media/Ballroll_00252.d6a3f09b.png";